import React from 'react';
import './Heading.css';

import { FaWifi } from 'react-icons/fa';



const Heading = ({ title, subTitle = '', sideHeading = false, linear = false }) => {

  return (
    <div className={`heading ${sideHeading ? 'sideheading' : ''} ${linear ? 'linear-bg' : ''}`}>

      {/* Render the subTitle section only if subTitle is provided */}
      {subTitle && (
        <div className="sub">

          {/* Render the left icon only when sideHeading is false */}
          {!sideHeading && <FaWifi className="icon" />}

          {/* Display the subtitle text */}
          <span>{subTitle}</span>

          {/* Always show the right icon */}
          <FaWifi className="icon" />

        </div>
      )}

      <h2>{title}</h2> {/* Display the title */}

    </div>
  );
};

export default Heading;